/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDto } from '../../models/document-dto';

export interface AdminDocumentControllerDeleteDocument$Params {
  id: string;
}

export function adminDocumentControllerDeleteDocument(http: HttpClient, rootUrl: string, params: AdminDocumentControllerDeleteDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDto>> {
  const rb = new RequestBuilder(rootUrl, adminDocumentControllerDeleteDocument.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentDto>;
    })
  );
}

adminDocumentControllerDeleteDocument.PATH = '/api/document-admin/{id}';
